import React, { useContext, useEffect, useState } from "react";
import { RedirectionButton } from "../tools/RedirectionButton";
import { useParams } from "react-router-dom";
import { ParcelsHandledAndDScan } from "./ParcelsHandledDScan";
import { MAWBInfoCard } from "./MAWBInfoCard";
import { AccumulativeCustomsCleared } from "./AccumulativeCustomsCleared";
import { DND } from "../../../components/dnd";
import { MAWBVolumeHandled } from "./MAWBVoulmeHandled";
import { MAWBDates } from "../tools/MAWBDates";
import { useParcelsMawb } from "../../../services/clear-customs/mawb";
import { MAWBThroughputChart } from "./MAWBThroughput";
import APIContext from "../../../services/api/api";
import { URLS } from "../../../configuration/urls";
import { Box, CircularProgress, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const TODAY = new Date()?.toISOString()?.split("T")[0];

export function MAWBKPI() {
  const { getData } = useContext(APIContext);
  const queryParameters = useParams();
  const [isAvailable, setIsAvailable] = useState({ isAvailable: false });
  const [isLoading, setIsLoading] = useState(false);

  const defaultComponents = [
    { name: "ParcelsHandledAndDScan", id: "parcels_handled_dscan", component: ParcelsHandledAndDScan },
    { name: "AccumulativeCustomsCleared", id: "accumulative_customs_cleared", component: AccumulativeCustomsCleared },
    { name: "MAWBVolumeHandled", id: "mawb_volume_handled", component: MAWBVolumeHandled },
    { name: "MAWBThroughputChart", id: "mawb_throughput_chart", component: MAWBThroughputChart }
  ];
  const { dScanMawb } = useParcelsMawb();
  const categories = dScanMawb?.map(item => item?.date || "");

  useEffect(() => {
    async function handleFetchAvailability() {
      setIsLoading(true);
      try {
        const result = await getData(`h7/kpi/mawb/${queryParameters?.id}/kpi-availability`, {}, URLS.EC_CLEAR_CUSTOMS_BE());
        setIsAvailable(result);
      } finally {
        setIsLoading(false);
      }
    }

    handleFetchAvailability();
  }, [queryParameters?.id]);


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }}>
      <RedirectionButton />
      <section data-testid="mawb_card_box">
        <MAWBInfoCard today={TODAY} id={queryParameters?.id} />
      </section>
      {!isLoading ?
        <>
          {isAvailable.isAvailable ?
            <>
              <MAWBDates dates={categories} />
              <DND id={queryParameters?.id} defaultComponents={defaultComponents} today={TODAY} />
            </>
            :
            <Typography style={{ textAlign: "center", padding: "3rem", fontWeight: "bold" }} variant="subtitle1">
              <FormattedMessage id="noData" defaultMessage="No data" />
            </Typography>
          }
        </>
        :
        <Box display="flex" justifyContent="center" alignItems="center" py={6}>
          <CircularProgress size={30} />
        </Box>
      }
    </div>
  );
}
